import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';

import { Autoplay, Navigation } from 'swiper';
import {
  ClipboardCheckIcon,
  GiftIcon,
  PhoneIcon,
  ShieldCheckIcon,
  ShoppingBagIcon,
  TruckIcon
} from '@heroicons/react/outline';
import {
  add_to_cart,
  content,
  description,
  detail,
  image,
  main_content,
  name,
  out_of_stock_status,
  p_code,
  row,
  support,
  variation,
  wrapper
} from './product.module.scss';
import { getDefaultSelection, getProductBrand, getProductBrandLink } from 'utils/productCollectionUtils';
import { useEffect, useState } from 'react';

import AddToCartButton from 'Components/Cart/AddToCartButton';
import DetailPrice from 'Components/ProductDetail/DetailPrice';
import Footer from 'Components/Footer';
import Link from 'next/link';
import { OUT_OF_STOCK } from 'Lib/constants/product';
import { PRODUCT_TYPE } from 'Lib/constants/page';
// import ProductSlide from './ProductSlide';
import { URI_TYPE_PATH } from 'Lib/constants/path';
import classNames from 'classnames';
import dynamic from 'next/dynamic';
import { getProductGallery } from 'utils/product-image';

const ProductMeta = dynamic(() =>
  import('Components/ProductDetail/ProductMeta')
);
const Variation = dynamic(() => import('./Variation'));
const ProductSlide = dynamic(() => import('./ProductSlide'));

export default function DesktopDetail({ product }) {
  const [selectedVariation, setSelectedVariation] = useState(null);

  const outOfStock = product.stockStatus === OUT_OF_STOCK
  const productImages = getProductGallery(product);
  const productBrand = getProductBrand(product.productBrands);

  useEffect(() => {
      if(product.variations.nodes.length > 0) {
        let defaultSelect = getDefaultSelection(product.variations.nodes)
        setSelectedVariation(defaultSelect);
      }
  }, [product.variations])

  const handleSelection = (item) => {
    setSelectedVariation(item);
  };
  return (
    <>
      <article className={wrapper}>
        <div className="container mb-20 flex">
          <div className="w-9/12">
            <div className={main_content}>
              <div className={image}>
                <ProductSlide data={productImages} />
              </div>
              <div className={detail}>
                <h1 className={name}>{product.name}</h1>

                <span className={p_code}></span>
                {productBrand && (
                  <div>
                    <span>Thương hiệu: </span>
                    <Link href={getProductBrandLink(productBrand)}>
                      <a>
                        <span className="font-semibold">{productBrand.name}</span>
                      </a>
                    </Link>
                  </div>
                )}
                <DetailPrice
                  product={
                    product.type === PRODUCT_TYPE.VARIABLE
                      ? selectedVariation
                      : product
                  }
                />
                {product.type === PRODUCT_TYPE.VARIABLE && (
                  <Variation
                    variations={product.variations.nodes}
                    onSelect={handleSelection}
                    className={variation}
                  />
                )}
                {
                  !outOfStock ? <AddToCartButton
                    buttonIcon={<ShoppingBagIcon className="h-6 w-6 stroke-1" />}
                    productId={
                      product.type === PRODUCT_TYPE.VARIABLE
                        ? selectedVariation?.databaseId
                        : product?.databaseId
                    }

                  />
                    : <span className={out_of_stock_status}>Sản phẩm hết hàng</span>
                }
                <div className="flex items-center py-2 text-primary_color-0">
                  <span>Gọi đặt hàng</span>
                  <PhoneIcon className="ml-2 h-4 w-4 stroke-1" />
                  <span className="ml-1 font-semibold">0898 318 328</span>
                  <span>(9:00-21:00)</span>
                </div>
              </div>
            </div>
            <div className={content}>
              <h3 className="block text-lg ">Mô tả</h3>
              <div
                className={description}
                dangerouslySetInnerHTML={{
                  __html: product.description
                }}
              />
            </div>
          </div>
          <div className="w-3/12">
            <Support className="mb-5" />
            <div className={classNames(content, 'border border-slate-200 p-2')}>
              <h3 className="text-lg">Thông tin sản phẩm</h3>
              <ProductMeta product={product} />
            </div>
          </div>
        </div>
      </article>
    </>
  );
}

const Support = ({ className }) => {
  return (
    <div className={classNames(support, className)}>
      <div className={row}>
        <ShieldCheckIcon />
        <div className="ml-4">
          <p className="font-semibold">Cam kết hàng chính hãng 100%</p>
          <p>Hoàn tiền 200% nếu phát hiện hàng giả</p>
        </div>
      </div>
      <div className={row}>
        <TruckIcon />
        <div className="ml-4">
          <p className="font-semibold">Giao hàng miễn phí toàn quốc</p>
          <p>Giao nội thành TPHCM trong vòng 3H</p>
        </div>
      </div>
      <div className={row}>
        <GiftIcon />
        <div className="ml-4">
          <p className="font-semibold">Miễn phí gói quà</p>
        </div>
      </div>
      <div className={row}>
        <ClipboardCheckIcon />
        <div className="ml-4">
          <p className="font-semibold">Cửa hàng uy tín</p>
        </div>
      </div>
    </div>
  );
};
